<template>
    <div class="contents">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">
                                    List Shop
                                </h4>
                            </div>
                        </div>
                        <div class="action-btn">
                            <router-link to="/shop/tutorial" class="btn px-15 btn-info text-white" style="display:inline-flex; margin:5px">
                                <i class="fas fa-book-open fs-16"></i> &nbsp;Tutorial
                            </router-link>
                            <router-link to="/shop-balance" class="btn px-15 btn-success text-white" style="display:inline-flex; margin:5px">
                                <i class="fas fa-wallet fs-16"></i> &nbsp;Saldo Toko
                            </router-link>
                            <a v-on:click="toggleModal('new_shop')" class="btn px-15 btn-primary text-white"
                                style="display: inline-flex; margin: 5px">
                                <i class="fas fa-plus fs-16"></i>
                                Tambah Shop
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="shopQuota == -1" class="alert alert-success" role="alert">
                <div class="alert-content">
                    <p>Batas shop maksimal anda adalah <b>Unlimited</b> shop</p>
                </div>
            </div>
            <div v-else-if="shopQuota == 0" class="alert alert-danger" role="alert">
                <div class="alert-content">
                    <p>Batas shop maksimal anda adalah <b>{{ shopQuota }}</b> shop</p>
                </div>
            </div>
            <div v-else class="alert alert-primary" role="alert">
                <div class="alert-content">
                    <p>Batas shop maksimal anda adalah <b>{{ shopQuota }}</b> shop</p>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <ShopTable @view-detail="viewDetail" @delete-shop="deleteShop" />
                    </div>
                </div>
            </div>
            <modal name="new_shop" :height="'auto'" :adaptive="true" :scrollable="true">
                <div style="margin: 20px">
                    <ShopForm @close="closeModal" @saved="refreshTable" />
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import ShopTable from "@/components/tables/Shop.vue";
    import ShopForm from "@/components/forms/shop/ShopForm.vue";

    export default {
        components: {
            ShopTable,
            ShopForm,
        },
        data() {
            return {
                shopQuota: ""
            };
        },
        mounted() {
            this.shopQuota = this.$store.state.auth.package?.max_shop || 0
        },
        methods: {
            toggleModal(param) {
                this.$modal.toggle(param);
            },
            closeModal() {
                this.$modal.hide('new_shop');
            },
            viewDetail(shopId) {
                this.$router.push(`/shop/${shopId}`);
            },
            deleteShop(shopId) {
                if (confirm('Apakah anda yakin ingin menghapus shop ini?')) {
                    this.$store.dispatch('shop/shop_delete', shopId)
                        .then(() => {
                            this.$toast.success('Shop berhasil dihapus');
                            this.refreshTable();
                        })
                        .catch(err => {
                            this.$toast.error(err.response?.data?.message || 'Gagal menghapus shop');
                        });
                }
            },
            refreshTable() {
                this.$root.$emit('refresh-shop-table');
                this.closeModal();
            },
        },
    };
</script>
